import PropTypes from "prop-types"
import React from "react"
import DealCard from "src/main/MarinaProfile/DockwaPlusDeals/DealCard"

import { DockwaPlusDealsLogoBlack } from "src/components/DockwaPlus/Logos"
import Modal from "src/components/Modal"

const ViewAllDealsModal = ({
  isOpen,
  setIsOpen,
  dockwaPlusReservationDeals,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Modal.Header>
        <DockwaPlusDealsLogoBlack />
        <div className="pt-1">
          The following discounts automatically apply for Dockwa+ members on
          eligible dates.
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col space-y-4">
          {dockwaPlusReservationDeals?.map((dockwaPlusDeal) => (
            <DealCard dockwaPlusDeal={dockwaPlusDeal} key={dockwaPlusDeal.id} />
          ))}
        </div>
      </Modal.Body>
    </Modal>
  )
}

ViewAllDealsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  dockwaPlusReservationDeals: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      discount: PropTypes.number.isRequired,
      category: PropTypes.string.isRequired,
      expiresAt: PropTypes.string,
      validRangeReadable: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      readableDiscount: PropTypes.string.isRequired,
      expiresSoon: PropTypes.bool.isRequired,
    })
  ),
}

export default ViewAllDealsModal
